import Swal, { SweetAlertResult } from "sweetalert2";
import { SweetAlertOptions } from "sweetalert2";
import { CustomAlertProps } from "types/alert/CustomAlertProps";

export default function showAlert(props: CustomAlertProps) {
  const sweetAlertOptions = getSweetAlertOptions(props);

  const customSwal = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger-alt me-2 pe-3 ps-3",
      confirmButton: "btn btn-primary pe-3 ps-3",
    },
    buttonsStyling: false,
  });

  customSwal.fire(sweetAlertOptions).then((result: SweetAlertResult<any>) => {
    if (result.isConfirmed && props.onConfirm) {
      props.onConfirm();
    } else if (props.onCancel) {
      props.onCancel();
    }
  });
}

const getSweetAlertOptions = (props: CustomAlertProps): SweetAlertOptions => {
  let title = props.titulo ? props.titulo : "";
  let text = props.texto ? props.texto : "";
  let icon = props.icon ? props.icon : "warning";
  let showCancelButton = props.tipoAlerta === "CONFIRMAR_CANCELAR_ALERT" ? true : false;
  let cancelButtonText = props.labelBotaoCancelar ? props.labelBotaoCancelar : "Não";
  let confirmButtonText = props.tipoAlerta === "OK_ALERT" ? "Ok" : "Sim";

  if (props.labelBotaoConfirmar) {
    confirmButtonText = props.labelBotaoConfirmar;
  }

  return {
    title: title,
    text: text,
    icon: icon,
    showCancelButton: showCancelButton,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    reverseButtons: true,
    focusConfirm: true,
  };
};
